/** 3 loại bình — dùng trong trận, mua bằng vàng. */
export type PotionKind = 'hp' | 'mana' | 'stamina';

export interface PotionDef {
  id: PotionKind;
  name: string;
  desc: string;
  price: number;
  /** hồi theo % chỉ số tối đa */
  pct?: number;
  /** thời gian hiệu lực */
  duration?: number;
  /** hệ số tăng sức mạnh khi dùng bình stamina */
  powerMult?: number;
  color: number;
  icon: string;
}

export const POTIONS: Record<PotionKind, PotionDef> = {
  hp: {
    id: 'hp',
    name: 'Bình Máu',
    desc: 'Hồi ngay 45% máu tối đa',
    price: 60,
    pct: 0.45,
    color: 0xef4444,
    icon: '♥',
  },
  mana: {
    id: 'mana',
    name: 'Bình Mana',
    desc: 'Hồi ngay 60% mana tối đa',
    price: 50,
    pct: 0.6,
    color: 0x3b82f6,
    icon: '✦',
  },
  stamina: {
    id: 'stamina',
    name: 'Bình Thể Lực',
    desc: 'BẤT TỬ 5s + tăng 60% sức mạnh. Tối đa 2 bình/trận.',
    price: 150,
    duration: 5,
    powerMult: 1.6,
    color: 0xf59e0b,
    icon: '⚡',
  },
};

/** Giới hạn chống phá game — yêu cầu bạn nêu "bất tử" phải bị giới hạn. */
export const MAX_STAMINA_POTIONS_PER_STAGE = 2;

/** Giá mua đạn của class Quân đội. */
export const AMMO_PACK_SIZE = 30;
export const AMMO_PACK_PRICE = 80;
